// stores/rootStore.js
import {
  makeAutoObservable,
  runInAction,
  autorun,
  observable,
  reaction,
} from "mobx";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { commonAxios } from "../../ExperianPage/CommonAxios";
import { v4 as uuidv4, validate } from "uuid";
import { showAlertToast } from "../../../Components/ToastComponent/AlertMessage";
import MultiSelectStore from "../../ExperianPage/store/MultiSelectStore";
import { downloadFileFromURL } from "../../../Components/utils"
class MatchAppendStore {
  UserId = "";
  fileData = null;
  apiloader = false;
  headers = [];
  recentUploads = [];
  fileName = "";
  isLoading = false;
  isDragging = false;
  showMatchModal = false;
  CommonLoader = false;
  triggerCommonLoader = false;
  selectedValues = {
    threshold: "83",
  };
  enhanceselectedValues = {
    no: "1",
    ctps: false,
    emailValidate: false,
  };
  modalStep = 0;
  fileImporttype = "";
  fieldSelect = [
    { label: "Company Name", value: "company_name" },
    { label: "Address Line 1", value: "addressline1" },
    { label: "Address Line 2", value: "addressline2" },
    { label: "Address Line 3", value: "addressline3" },
    { label: "Address Line 4", value: "addressline4" },
    { label: "Address Line 5", value: "addressline5" },
    { label: "URN (Experian)", value: "company_id" },
    { label: "Post Code", value: "post_code" },
  ];
  enchanceSelectJobGroup = [];
  chartTypes = [
    { label: "Company", value: "company" },
    { label: "People", value: "people" },
    { label: "Email", value: "Email" },
    { label: "Suppression", value: "Suppression" },
  ];
  info = {};
  dynamicFlags = observable.map({
    chartType: "company",
  });
  currentTab = "Company";
  validationErrors = {};
  verifyOptions = {
    emailValidate: false,
    ctps: false,
    basic: false,
    advanced: false,
  };
  fetchRecentTable;
  enrichmentList = [];
  statisticData = {};
  selectedCheckboxes = new Map();
  selectedCheckboxescompany = new Map();
  searchTerm = "";
  searchTermfilter = "";
  currentPage = 0;
  entriesPerPage = 10;
  totalCount = 0;
  pageCount = 0;
  peopleEnhance = false;
  peopleexcludearray = ["additionalContacts", "directors"];
  totalcredits = {
    company: 0,
    people: 0,
  }

  constructor(rootstore) {
    this.rootStore = rootstore;
    this.gridStore = rootstore.gridStore;
    makeAutoObservable(this);
    this.setupAutorun();
  }
  getAllSelectedValues() {
    return this.rootStore.getAllSelectedValues();
  }
  setCurrentPage = (page) => {
    runInAction(() => {
      this.currentPage = page;
    });
    this.fetchRecentTable();
  };
  setEntriesPerPage = (count) => {
    runInAction(() => {
      this.entriesPerPage = count;
      this.currentPage = 0; // Reset to first page when changing page size
    });
    this.fetchRecentTable();
  };
  setTotalCount = (count) => {
    runInAction(() => {
      this.totalCount = count;
      this.pageCount = Math.ceil(count / this.entriesPerPage);
    });
  };
  setCurrentTab = (tab) => {
    runInAction(() => {
      this.currentTab = tab;
      this.fetchEnrichMentKey();
    });
  };
  settotalcredits = (credit, name) => {
    runInAction(() => {
      this.totalcredits = {
        ...this.totalcredits,
        [name]: credit,
      };
    });
  };
  gettotalcredits = (name) => {
    return this.totalcredits[name];
  }
  setLoader(status) {
    this.triggerCommonLoader = status;
  }
  formatDate = (isoDateString) => {
    const date = new Date(isoDateString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };
  setinfodetails = (data) => {
    runInAction(() => {
      this.info = data;
    });
  };
  getinfodetails = () => {
    return this.info;
  };
  setModalStep = (value) => {
    runInAction(() => {
      this.modalStep = value;
    });
  };
  toggleCheckbox = (headerValue, fieldValue, credit) => {
    const temp = this.gettotalcredits("people");
    runInAction(() => {
      if (!this.selectedCheckboxes.has(headerValue)) {
        this.selectedCheckboxes.set(headerValue, new Set());
      }
      const set = this.selectedCheckboxes.get(headerValue);
      const isSelected = set.has(fieldValue);
      if (isSelected) {
        set.delete(fieldValue);
        // Remove credit only if last field is deselected
        if (set.size === 0) {
          this.selectedCheckboxes.delete(headerValue);
          this.settotalcredits(temp - credit, "people");
        }
      } else {
        const wasEmpty = set.size === 0;
        set.add(fieldValue);
        // Add credit only if first field is selected
        if (wasEmpty) {
          this.settotalcredits(temp + credit, "people");
        }
      }
    });
  };
  isFieldSelectedPeople = (headerValue, fieldValue) => {
    return (
      this.selectedCheckboxes.has(headerValue) &&
      this.selectedCheckboxes.get(headerValue).has(fieldValue)
    );
  };
  toggleCheckboxcompany = (bundleKey, fieldValue, price) => {
    const temp = this.gettotalcredits("company");
    runInAction(() => {
      if (!this.selectedCheckboxescompany.has(bundleKey)) {
        this.selectedCheckboxescompany.set(bundleKey, new Set());
      }
      const set = this.selectedCheckboxescompany.get(bundleKey);
      const isSelected = set.has(fieldValue);
      if (isSelected) {
        set.delete(fieldValue);
        // If all deselected → remove bundle and deduct credits
        if (set.size === 0) {
          this.selectedCheckboxescompany.delete(bundleKey);
          this.settotalcredits(temp - price, "company");
        }
      } else {
        const wasEmpty = set.size === 0;
        set.add(fieldValue);
        // First item selected → add price to credit
        if (wasEmpty) {
          this.settotalcredits(temp + price, "company");
        }
      }
    });
  };
  isFieldSelected = (headerValue, fieldValue) => {
    return (
      this.selectedCheckboxescompany.has(headerValue) &&
      this.selectedCheckboxescompany.get(headerValue).has(fieldValue)
    );
  };
  setImportType = (value) => {
    runInAction(() => {
      this.fileImporttype = value;
    });
  };
  setSearchTerm = (term) => {
    runInAction(() => {
      this.searchTerm = term.toLowerCase();
    });
    // this.fetchRecentTable();
  };
  setSearchTermfilter = (term) => {
    runInAction(() => {
      this.searchTermfilter = term.toLowerCase();
    });
    // this.fetchRecentTable();
  };
  get filteredEnrichmentList() {
    if (!this.searchTermfilter) return this.enrichmentList;
    const lowerSearch = this.searchTermfilter.toLowerCase();
    const filtered = this.enrichmentList.filter(
      (item) =>
        item.value.toLowerCase().includes(lowerSearch) ||
        item.label.toLowerCase().includes(lowerSearch)
    );
    // Remove duplicates by 'value'
    const uniqueMap = new Map();
    for (const item of filtered) {
      if (!uniqueMap.has(item.value)) {
        uniqueMap.set(item.value, item);
      }
    }
    return Array.from(uniqueMap.values());
  }
  validateEnhanceFields = () => {
    const errors = {};
    if (!this.enhanceselectedValues.jobgroup) {
      errors.jobgroup = "Job Group is required";
    }
    if (
      !this.enhanceselectedValues.no ||
      isNaN(this.enhanceselectedValues.no)
    ) {
      errors.no = "Valid number is required";
    }
    runInAction(() => {
      this.validationErrors = errors;
    });
    return Object.keys(errors).length === 0;
  };
  validateCompanyFields = () => {
    const error = {};
    if (!this.verifyOptions.basic && !this.verifyOptions.emailValidate) {
      error.basic = "Type is required";
    }
    runInAction(() => {
      this.validationErrors = error;
    });
    return Object.keys(error).length === 0;
  };
  handleConfirmEnhance = () => {
    if (this.validateCompanyFields()) {
      this.setCurrentTab("verify");
    }
  };
  setupAutorun() {
    autorun(() => {
    });
  }
  async processFile(file) {
    if (file.size > 10485760) {
      showAlertToast({
        type: "info",
        title: "Import Data ",
        message: "File size must be below 10MB",
      });
      return;
    }
    this.setLoading(true);
    this.setFileName(file.name);
    // this.setShowMatchModal(false);
    this.resetSelectedValues();
    try {
      const data = await this.readFile(file);
      if (data.length > 50000) {
        showAlertToast({
          type: "info",
          title: "Import Data ",
          message: "File length must be below 50K",
        });
        return;
      }
      runInAction(() => {
        this.fileData = data;
        this.headers = data.length > 0 ? Object.keys(data[0]) : [];
        this.isLoading = false;
        // this.showMatchModal = true;
        showAlertToast({
          type: "success",
          title: "File upload ",
          message: "File uploaded Successfully",
        });
      });
    } catch (error) {
      runInAction(() => {
        this.isLoading = false;
      });
    } finally {
    }
  }
  readFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const content = event.target.result;
          const lines = content
            .split(/\r?\n/)
            .filter((line) => line.trim() !== "");
          if (lines.length === 0) throw new Error("Empty file");
          const headers = lines[0].split(",").map((header) => header.trim());
          const result = [];
          for (let i = 1; i < lines.length; i++) {
            const obj = {};
            const currentline = lines[i].split(",");
            for (let j = 0; j < headers.length; j++) {
              obj[headers[j]] = currentline[j]?.trim();
            }
            result.push(obj);
          }
          resolve(result);
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsText(file);
    });
  }
  downloadSampleFiles = async () => {
    const zip = new JSZip();
    zip.file(
      "SampleFiles/Companyname.csv",
      "google \n apple \n shell\n BP\n Uniliver"
    );
    zip.file(
      "SampleFiles/Linkedin.csv",
      "https://www.linkedin.com/company/google \n https://www.linkedin.com/company/apple \n https://www.linkedin.com/company/shell \n https://www.linkedin.com/company/BP \n https://www.linkedin.com/company/Uniliver"
    );
    zip.file(
      "SampleFiles/Domain.csv",
      "google.com\n website.com\n network.com\n yahoo.com\n facebook.com"
    );
    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, "sample_files.zip");
    });
  };
  handleFieldChange = (fieldName, value) => {
    runInAction(() => {
      this.selectedValues = {
        ...this.selectedValues,
        [fieldName]: value,
      };
    });
  };
  handleFieldChangeenhance = (fieldName, value) => {
    if (fieldName === 'no') {
      this.validationErrors.jobgroup = false;
    }
    runInAction(() => {
      this.enhanceselectedValues = {
        ...this.enhanceselectedValues,
        [fieldName]: value,
      };
    });
  };
  handleSubmitMappings = async () => {
    const selectedValues = JSON.parse(JSON.stringify(this.selectedValues));
    const payload = {
      ...selectedValues,
      ...(this.fileImporttype === "company" && {
        threshold: this.selectedValues.threshold || 83,
      }),
    };
    runInAction(() => {
      this.apiloader = true;
    });
    let submitRes;
    try {
      submitRes = await commonAxios(
        "/importData",
        "POST",
        {},
        {
          matchData: payload,
          formData: this.fileData,
          fileName: this.fileName,
          userId: this.UserId,
          importUniqueId: uuidv4(),
          type: this.fileImporttype === "Company" ? "company" : "people",
        }
      );
    } catch (e) {
      showAlertToast({
        type: "error",
        title: "Error",
        message: "Failed to import data",
      });
    }

    
    runInAction(() => {
      if (submitRes?.statusCode === 200) {
        this.apiloader = false;
        showAlertToast({
          type: "success",
          title: "Import Data Success",
          message: "File importted Successfully",
        });
      }
      this.showMatchModal = false;
      this.handleCloseModal();
    });
    this.fetchRecentTable();
  };
  allowdisplay = (key) => {
    if (this.selectedCheckboxes.has(key)) {
      return true;
    }
    return false;
  };
  handleSubmitEnhance = async () => {
    try {
      this.setLoader(true);
      const payload = Object.entries(this.enhanceselectedValues).reduce(
        (acc, [key, value]) => {
          if (typeof key === "string" && !key.startsWith("Symbol(")) {
            acc[key] = value;
          }
          return acc;
        },
        {}
      );
      let extractedValues;
      if (this.peopleEnhance) {
        const selectstore = this.dynamicFlags.get("ContactJobTitle");
        const valuesArray = selectstore?.selectedValues; // Proxy(Array)
        extractedValues = valuesArray.map((item) => item.value).join(",");
        if (!extractedValues && extractedValues.length === 0 && this.peopleEnhance) {
          showAlertToast({
            type: "error",
            title: "Field Missing",
            message: 'JobGroup is not allowed to be empty',
          });
          this.validationErrors.jobgroup = true;
          this.setLoader(false);
          return;
        } else {
          this.validationErrors.jobgroup = false;
        }
        if (payload.no === "" || payload.no === null) {
          showAlertToast({
            type: "error",
            title: "Field Missing",
            message: 'No of Contacts is not allowed to be empty',
          });
          this.setLoader(false);
          return;
        }
      }
      const selectedValuesString = Array.from(
        this.selectedCheckboxes.keys()
      ).join(",");
      if (this.peopleEnhance === true) {
        if (selectedValuesString.length === 0) {
          showAlertToast({
            type: "error",
            title: "Bundle Missing",
            message: "Select atleast one bundle",
          });
          this.setLoader(false);
          return;
        }
      }
      const selectedValuesStringcompany =
        this.selectedCheckboxescompany.size > 0
          ? Array.from(this.selectedCheckboxescompany.keys()).join(",")
          : "";
      let selectedCustomField = "";
      let keyValueObject = "";
      if (this.peopleEnhance) {
        const companyFields = Array.from(this.selectedCheckboxescompany.values())
          .flatMap((set) => Array.from(set));
        const peopleFields = Array.from(this.selectedCheckboxes.values())
          .flatMap((set) => Array.from(set));
        const combinedFields = [...companyFields, ...peopleFields];
        selectedCustomField = combinedFields.length > 0 ? combinedFields.join(",") : "";
        keyValueObject = Object.fromEntries([
          ...Array.from(this.selectedCheckboxescompany.entries()).map(([key, valueSet]) => [
            key,
            Array.from(valueSet),
          ]),
          ...Array.from(this.selectedCheckboxes.entries()).map(([key, valueSet]) => [
            key,
            Array.from(valueSet),
          ])
        ]);
      }
      else {
        const companyFields = Array.from(this.selectedCheckboxescompany.values())
          .flatMap((set) => Array.from(set));
        selectedCustomField = companyFields.length > 0 ? companyFields.join(",") : "";
        keyValueObject = Object.fromEntries(
          Array.from(this.selectedCheckboxescompany.entries()).map(([key, valueSet]) => [
            key,
            Array.from(valueSet),
          ])
        );
      }
      const postenhance = await commonAxios(
        "/match/companyPeople",
        "POST",
        {},
        {
          peopleFields: this.peopleEnhance ? selectedValuesString : "",
          jobGroup: extractedValues,
          noOfContact: payload.no,
          // emailValidation: payload.emailValidate,
          // suppression: payload.ctps,
          userId: this.UserId,
          tableId: this.dynamicFlags.get("currentFileId"),
          companyFields: selectedValuesStringcompany,
          customFields: selectedCustomField,
          fieldsInfo: keyValueObject
        }
      );
      if (postenhance.statusCode === 200) {
        runInAction(() => {
          this.setLoader(false);
          this.fetchRecentTable();
          showAlertToast({
            type: "success",
            title: "Enrichment",
            message: postenhance?.data?.message ?? "",
          });
          this.handleCloseenrich();
          this.rootStore.getUserCredits();
        });
      } else {
        this.setLoader(false);
      }
      return true;
    } catch (error) {
      showAlertToast({
        type: "error",
        title: "Enrichment Failes",
        message: error?.response?.data?.error.message ?? "",
      });
      this.setLoader(false);
    }
  };
  handleSubmitEnhancecompany = async () => {
    try {
      this.setLoader(true);
      const payload = Object.entries(this.enhanceselectedValues).reduce(
        (acc, [key, value]) => {
          if (typeof key === "string" && !key.startsWith("Symbol(")) {
            acc[key] = value;
          }
          return acc;
        },
        {}
      );
      const selectstore = this.dynamicFlags.get("ContactJobTitle");
      const valuesArray = selectstore.selectedValues; // Proxy(Array)
      const extractedValues = valuesArray.map((item) => item.value).join(",");
      const peopleFieldsString = Array.from(this.selectedCheckboxes.values())
        .flatMap(set => Array.from(set))
        .join(',');
      const keyValueObject = Object.fromEntries(
        Array.from(this.selectedCheckboxes.entries()).map(([key, valueSet]) => [
          key,
          Array.from(valueSet),
        ])
      );
      if (!extractedValues && extractedValues.length === 0) {
        showAlertToast({
          type: "error",
          title: "Field Missing",
          message: '"JobGroup" is not allowed to be empty',
        });
        this.validationErrors.jobgroup = true;
        this.setLoader(false);
        return;
      } else {
        this.validationErrors.jobgroup = false;
      }
      if (payload.no === "" || payload.no === null) {
        showAlertToast({
          type: "error",
          title: "Field Missing",
          message: 'No of Contacts is not allowed to be empty',
        });
        this.setLoader(false);
        return;
      }
      const selectedValuesString = Array.from(
        this.selectedCheckboxes.keys()
      ).join(",");
      if (this.peopleEnhance === true) {
        if (selectedValuesString.length === 0) {
          showAlertToast({
            type: "error",
            title: "Bundle Missing",
            message: "Select atleast one bundle",
          });
          this.setLoader(false);
          return;
        }
      }
      const postenhance = await commonAxios(
        "/match/people",
        "POST",
        {},
        {
          peopleFields: selectedValuesString,
          jobGroup: extractedValues,
          noOfContact: payload.no,
          userId: this.UserId,
          tableId: this.dynamicFlags.get("currentFileId"),
          customFields: peopleFieldsString,
          fieldsInfo: keyValueObject
        }
      );
      if (postenhance.statusCode === 200) {
        runInAction(() => {
          this.setLoader(false);
          this.fetchRecentTable();
          showAlertToast({
            type: "success",
            title: "Enrichment",
            message: postenhance?.data?.message ?? "",
          });
          this.handleCloseenrich();
          this.rootStore.getUserCredits();
        });
      } else {
        this.setLoader(false);
      }
      return true;
    } catch (error) {
      showAlertToast({
        type: "error",
        title: "Enrichment Failes",
        message: error?.message ?? "",
      });
      this.setLoader(false);
    }
  };
  handleCloseModal = () => {
    runInAction(() => {
      this.showMatchModal = false;
      this.fileImporttype = "";
      this.modalStep = 0;
    });
    this.resetFile();
  };
  handleCloseenrich = () => {
    runInAction(() => {
      this.dynamicFlags.set("popupType", "");
      this.selectedCheckboxes.clear();
      this.selectedCheckboxescompany.clear();
      this.enhanceselectedValues = { no: "1" };
      this.dynamicFlags.get("ContactJobTitle")?.clearMe?.();
      this.totalcredits = {
        company: 0,
        people: 0
      };
      this.peopleEnhance = false;
    });
  };
  resetFile() {
    runInAction(() => {
      this.fileData = null;
      this.headers = [];
      this.fileName = "";
      this.showMatchModal = false;
      this.selectedValues = { threshold: "83" };
      this.isLoading = false;
    });
  }
  // State management methods
  setFileData(data) {
    runInAction(() => {
      this.fileData = data;
    });
  }
  setHeaders(headers) {
    runInAction(() => {
      this.headers = headers;
    });
  }
  setFileName(name) {
    runInAction(() => {
      this.fileName = name;
    });
  }
  setLoading(loading) {
    runInAction(() => {
      this.isLoading = loading;
    });
  }
  setDragging(dragging) {
    runInAction(() => {
      this.isDragging = dragging;
    });
  }
  setShowMatchModal(show) {
    runInAction(() => {
      this.showMatchModal = show;
    });
  }
  resetSelectedValues() {
    runInAction(() => {
      this.selectedValues = {};
    });
  }
  // Drag and drop handlers
  handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setDragging(true);
  };
  handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setDragging(false);
  };
  handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setDragging(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      if (file.type === "text/csv" || file.name.endsWith(".csv")) {
        this.processFile?.(file);
      } else {
        alert("Please upload a CSV file");
      }
    }
  };
  openStatisticsPopup = (fileId) => {
    runInAction(() => {
      this.dynamicFlags.set("currentFileId", fileId);
      this.dynamicFlags.set("popupType", "Statistics");
    });
    this.fetchStatisticsData();
  };
  openEnhancePopup = (fileId) => {
    runInAction(() => {
      this.dynamicFlags.set("currentFileId", fileId);
    });
    this.fetchEnrichMentKey();
  };
  setVerifyOption = (option, value) => {
    runInAction(() => {
      this.verifyOptions[option] = value;
    });
  };
  fetchUserId = async () => {
    // if (user.userId.length > 0) {
    //   runInAction(() => {
    //     this.UserId = user.userId;
    //   });
    this.fetchRecentTable();
    // }
  };
  fetchEnrichMentKey = async () => {

    this.setLoader(true);
    const enrichKey = await commonAxios(
      "/getEnrichKeywords",
      "GET",
      {
        type: this.currentTab === "Enhance" ? "contact" : "business",
      },
      {}
    );
    if (enrichKey.statusCode === 200) {
      runInAction(() => {
        this.enrichmentList = enrichKey.data.groupByFields;
        this.setLoader(false);
        this.dynamicFlags.set("popupType", "Enhance");
      });
      // this.fetchjobgroup();
    } else {
      this.setLoader(false);
    }
  };
  fetchjobgroup = async () => {
    const enrichKey = await commonAxios(
      "/searchFillter",
      "POST",
      {},
      {
        fillterKey: "ContactJobTitle",
        searchKeyword: "",
        nextCursorMark: "",
        userId: this.UserId,
      }
    );
    if (enrichKey.statusCode === 200) {
      runInAction(() => {
        this.dynamicFlags.set("popupType", "Enhance");
        this.enchanceSelectJobGroup = enrichKey.data.items;
      });
    }
  };
  setChartType = (type) => {
    runInAction(() => {
      this.dynamicFlags.set("chartType", type);
    });
  };
  fetchStatisticsData = async () => {
    const getstat = await commonAxios(
      "/getByStats",
      "GET",
      {
        userId: this.UserId,
        tableId: this.dynamicFlags.get("currentFileId"),
        type: this.dynamicFlags.get("chartType"),
      },
      {}
    );
    if (getstat.statusCode === 200) {
      runInAction(() => {
        this.dynamicFlags.set("popupType", "Statistics");
        this.statisticData = getstat?.data ?? {};
      });
    }
  };
  getstatisticsdata(key) {
    return this.statisticData[key];
  }
  fetchRecentTable = async () => {
    //  this.setLoader(true);
    const fetchRes = await commonAxios(
      "/import/history",
      "POST",
      {},
      {
        offset: this.currentPage * this.entriesPerPage,
        limit: this.entriesPerPage,
        search: this.searchTerm,
      }
    );
    if (fetchRes.statusCode === 200) {
      runInAction(() => {
        this.recentUploads = fetchRes.data.list;
        this.setTotalCount(fetchRes?.data?.totalCount ?? 11);
        // this.setLoader(false);
      });
    } else {
      // this.setLoader(false);
    }
  };
  downloadFile = async (id, name) => {
    try {
      this.setLoader(true);
      const res = await commonAxios(
        "/exportCSV",
        "POST",
        {},
        {
          tableId: id,
        }
      );
      if (res && res.data) {
        if (res?.data?.type === "blob") {
          if (!res?.data?.url || res?.data?.url === "") {
            showAlertToast({
              type: "error",
              title: "Error",
              message: "No URL found for the export file.",
            });
          } else if (res?.data?.url === "error") {
            showAlertToast({
              type: "error",
              title: "Error",
              message: "Error found.",
            });
          } else {
            // Download the blob from the URL
            const link = document.createElement("a");
            link.href = res?.data?.url;
            link.download = name ? `${name}.csv` : "export.csv";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        } else {
          downloadFileFromURL(res?.data?.url);
        }
        this.setLoader(false);
      }
    } catch (error) {
      this.setLoader(false);
    }
  }
  getFormattesStatus = (key) => {
    if (key === "pending") {
      return "Matching";
    } else if (key === "matchDone") {
      return "Matched";
    } else if (key === "enhancePending") {
      return "Enhancing";
    } else {
      return "Completed";
    }
    return key;
  };
  getEnhanceallow = (status, totalMatchedCount) => {
    if (totalMatchedCount == 0) {
      return true;
    }
    return (
      status === "pending" || status === "enhancePending" || status === "done"
    );
  };
  getStatallow = (status, totalMatchedCount) => {
    if (totalMatchedCount === 0) {
      return true;
    }
    return status === "pending";
  };
  getDynamicDropDown(fieldKey) {
    if (!this.dynamicFlags.has(fieldKey)) {
      this.dynamicFlags.set(fieldKey, new MultiSelectStore(this, fieldKey));
    }
    const store = this.dynamicFlags.get(fieldKey);
    console.log(store, "Got in store")
    return store;
  }
  handleEntriesToShowChange = (e) => {
    this.setEntriesPerPage(Number(e.target.value));
  };
  getSelectedUploadDetails = () => {
    const currentFileId = this.dynamicFlags.get("currentFileId");
    const selectedUpload = this.recentUploads.find(
      (upload) => upload.id === currentFileId
    );
    const matchedCounts =
      selectedUpload?.matchedCount?.find((obj) => obj.value === "CompanyID")
        ?.count || 0;
    return {
      currentFileId,
      selectedUpload,
      matchedCounts,
    };
  };
}
export default MatchAppendStore;
